import { FC, useState } from 'react';
import { collectionService } from '@/services/collections.service';
import styles from './CollectionLike.module.scss';

interface ICollectionLike {
  votes: number;
  id: number;
}

const CollectionLike: FC<ICollectionLike> = ({ votes, id }) => {
  const COLLECTION_IDS = 'collection-id';
  let userCollections: string[] = [];

  const [likesCount, setLikesCount] = useState(votes);
  const [likeNote, setLikeNote] = useState(false);
  const [allreadyVote, setAllreadyVote] = useState(false);

  //Достаем id коллекции из localStorages
  if (typeof window !== 'undefined' && localStorage.getItem(COLLECTION_IDS) !== null) {
    const getUserCollection = localStorage.getItem(COLLECTION_IDS) || '';
    const getUserCollectionString = JSON.parse(getUserCollection);
    userCollections.push(...getUserCollectionString);
  }

  const showLikeNote = () => {
    setLikeNote(true);
    setTimeout(() => {
      setLikeNote(false);
    }, 2500);
  };

  const postLikeToCollection = () => {
    if (userCollections.includes(String(id))) {
      setAllreadyVote(true);
    } else {
      collectionService.postLike(id);
      userCollections.push(String(id));
      localStorage.setItem(COLLECTION_IDS, JSON.stringify(userCollections));
      setLikesCount(likesCount + 1);
    }
    showLikeNote();
  };

  return (
    <li className={styles.like}>
      <span className={styles.like__btn} onClick={postLikeToCollection}>
        {likesCount}
      </span>
      {likeNote && <span className={styles.like__note}>{allreadyVote ? `Оценили ранее.` : `Cпасибо!`}</span>}
    </li>
  );
};
export default CollectionLike;
